(() => {
 const assets = window.LRL_ASSETS || {};
 const localize = value => {
  if (typeof value === 'string') return assets[value] || value.replace(/^https:\/\/lrlmotors\.com(?=\/)/, '');
  if (Array.isArray(value)) return value.map(localize);
  if (value && typeof value === 'object') Object.keys(value).forEach(key => value[key] = localize(value[key]));
  return value;
 };
 localize(window.LRL_DATA);
})();
